import placeholderImage from "./video_preview.png";

export const ImagePlaceholder = () => (
  <div className="wb-flex wb-justify-center wb-bg-black">
    <img
      src={placeholderImage}
      alt=""
      loading="eager"
      className="wb-max-h-[27rem]"
    />
  </div>
);
